import React from "react";
import { Button, Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

function StarekCinfirmationModal(props) {
  const { show, handleClose, handleDeleteNode, loading = false } = props;

  return (
    <Modal
      show={show}
      onHide={loading ? undefined : handleClose}
      size="sm"
      centered
      backdrop={loading ? "static" : true}
      keyboard={!loading}
    >
      <Modal.Header className="d-flex align-items-center justify-content-between">
        <Modal.Title>Confirm Delete?</Modal.Title>
      </Modal.Header>

      <Modal.Body>Are you sure you want to delete?</Modal.Body>

      <Modal.Footer className="d-flex align-items-center">
        <Button
          variant="outline-danger"
          onClick={handleClose}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button
          className="ms-2"
          variant="primary"
          onClick={() => !loading && handleDeleteNode?.()}
          disabled={loading}
        >
          {loading && (
            <span
              className="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            />
          )}
          {loading ? "Deleting…" : "Submit"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default StarekCinfirmationModal;
